import { render, staticRenderFns } from "./CompetitionEditSettings.vue?vue&type=template&id=25000064&"
import script from "./CompetitionEditSettings.vue?vue&type=script&lang=js&"
export * from "./CompetitionEditSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports